module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Italic.c99bb672.eot";